

















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { GetUserData } from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends Vue {
  private data: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetUserData(this, loading)
      .then((res: any) => {
        loading.close();
        this.data = res;
        this.$store.commit("updateUser", res);
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.getData();
  }
}
